import React from 'react'
import LogRow from "./LogRow";
import Api from '../../../services/Api'


class SiteHistory extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state ={
            searchIsPending : false,
            history : []
        }
    }

    getHistory()
    {
        let url = '/siteHistory?siteId=' + this.props.siteId;

        Api.get(url)
        .then(res => res.data)
        .then(posts => {
            this.setState({history: posts});
        }).catch((error) => {
            console.log(error);
            this.setState({searchIsPending:false})
        });
    }
    componentDidMount(): void {
        this.getHistory();
    }
    render() {
        const list = this.state.history.map((x, index) => {
               return  <LogRow 
                            key={x.id}
                            even = {index % 2 === 0}
                            changeDate={x.changeDate}
                            changeLog={x.changeLog}
                            user={x.user}
                    />
            }
        )
        return(
            <div style={{padding: '10px 0', minWidth: 500}}>
                {list}
            </div>
        );
    }
}
export default SiteHistory


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/SiteHistory.js